import { DashboardWidgetType } from 'src/constants/dashboard';
import type { DashboardResultOverview } from 'src/types/dashboard';
import useSurveyRootStatisticsData from 'src/components/dashboard/hooks/widgetData/useSurveyRootStatisticsData';

export const statisticsWidgets = [
  DashboardWidgetType.DOUGHNUT,
  DashboardWidgetType.SPEEDOMETER_RE,
];

const useStatisticsData = (dashboardResults?: DashboardResultOverview) => {
  const widgetType = dashboardResults?.widget?.widget_type;

  const {
    data: statisticsData,
    isFetching: isFetchingStatistics,
    errorMsg: errorMsgStatistics,
  } = useSurveyRootStatisticsData(
    dashboardResults,
    typeof widgetType === 'number' && statisticsWidgets.includes(widgetType),
  );
  const statisticsDataline = statisticsData?.focal_result?.dataline;

  return {
    statisticsData,
    isFetchingStatistics,
    errorMsgStatistics,
    statisticsDataline,
  };
};

export default useStatisticsData;
